export default __webpack_public_path__ + "static/testimonials-1-shape-3-3da602fdd60826e2de9bd09c784c181a.png";